<template>
  <div>
    <showInformationCustomerComponents />
  </div>
</template>

<script>
import showInformationCustomerComponents from "@/components/showInformationCustomerComponents.vue";
export default {
  components: {
    showInformationCustomerComponents,
  },
};
</script>
